/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { DescriptionParagraph } from '@source/pages/AboutUs/components/DescriptionParagraph';
import {
  AboutContentType,
  aboutUsContentByCountry,
  getContentAboutDesc,
  getTimelineContent,
} from '@source/pages/AboutUs/content';
import { Trans, useTranslation } from 'next-i18next';
import { getStaticCDN } from '@design-system/utils/utils';
import StyledContainer from '@design-system/styled/Container';

import { TRegionKey } from '@source/interface';

const StyledAboutContainer = styled.div`
  padding: 60px 16px 40px;
  background-color: #fff;
  overflow: hidden;
  text-align: center;
`;
const StyledLogo = styled.div`
  text-align: center;
`;
const StyledVision = styled.div`
  padding: 0 60px;

  .subtitle {
    line-height: 25px;

    p:not(:last-child) {
      padding-bottom: 25px;
      margin-bottom: 0 !important;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 0 5px;
  }
`;

const AboutCarro = ({ region }: { region: TRegionKey }) => {
  const { i18n, t } = useTranslation('aboutUs');

  const loadContent = useCallback(
    (contentType: AboutContentType, descNumber = 4) => {
      const descs = getContentAboutDesc(contentType, region, descNumber);

      return descs
        .filter((item) => i18n.exists(item))
        .map((item, index) => (
          <p key={index}>
            <Trans defaults={item} components={{ a: <a /> }} ns="aboutUs" />
          </p>
        ));
    },
    [i18n, region],
  );

  const loadTimelineContent = useCallback(
    (contentType: AboutContentType, descNumber?: number) => {
      const descs = getTimelineContent(contentType, region, descNumber);

      return descs
        .filter((item) => i18n.exists(item.descMain) || i18n.exists(item.descSub))
        .map((item) => ({
          time: i18n.exists(item.time) ? <Trans defaults={item.time} ns="aboutUs" /> : '',
          descMain: i18n.exists(item.descMain) ? (
            <Trans defaults={item.descMain} components={{ span: <span /> }} ns="aboutUs" />
          ) : (
            ''
          ),
          descSub: i18n.exists(item.descSub) ? (
            <Trans defaults={item.descSub} components={{ span: <span /> }} ns="aboutUs" />
          ) : (
            ''
          ),
        }));
    },
    [i18n, region],
  );

  return (
    <StyledAboutContainer>
      <StyledContainer>
        <StyledLogo>
          <img src={getStaticCDN('/assets/shared/about-us/about_logo.svg')} alt="about carro" />
        </StyledLogo>
        <StyledVision>
          {aboutUsContentByCountry[region]?.map((c, index) => (
            <DescriptionParagraph
              key={index}
              title={t(c.title)}
              description={loadContent(c.content, c.descNumber)}
              type={c.type}
              timelineContent={loadTimelineContent(c.content)}
            />
          ))}
        </StyledVision>
      </StyledContainer>
    </StyledAboutContainer>
  );
};

export default AboutCarro;
